import * as React from 'react';
import ButtonBase from '@mui/material/ButtonBase';
import cn from 'classnames';

import { EngineTheme, useMergeClasses, useTheme } from '../../../../../../theme';
import { CardExtraView } from '../CardExtraView';
import { CdnIcon, SafeHtml } from '@shared/ui';

type Props = React.ComponentProps<typeof CardExtraView> & {
	aggregatorClasses?: EngineTheme['Shared']['CardExtraView']['CardExtraViewAggregator'];
	headerIcons?: React.ReactNode;
	onAdd?: () => void;
	onDelete?: () => void;
};

const CardExtraViewAggregator: React.FC<Props> = ({
	icon,
	title,
	description,
	classes,
	aggregatorClasses,
	headerIcons,
	headerControls,
	content,
	onAdd,
	onDelete,
	...props
}) => {
	const { CardExtraViewAggregator: defaultClasses } = useTheme('Shared').CardExtraView;

	const theme = useMergeClasses(defaultClasses, aggregatorClasses);
	const cardExtraViewTheme = useMergeClasses(theme, classes);

	const descriptionContent =
		description && typeof description === 'string' ? (
			<SafeHtml className={theme.description} html={description} />
		) : (
			<div className={theme.description}>{description}</div>
		);

	const isSelected = !onAdd || !!onDelete;

	return (
		<CardExtraView
			{...props}
			classes={cardExtraViewTheme}
			icon={<></>}
			headerControls={
				<>
					{headerControls}
					{headerIcons && <div className={theme.icons}>{headerIcons}</div>}
					<ButtonBase
						className={cn(theme.buttonStatus, { [theme.buttonStatus_selected]: isSelected })}
						aria-hidden="false"
					>
						<CdnIcon icon={isSelected ? 'Info/Check' : 'Action/Add'} />
					</ButtonBase>
				</>
			}
			content={
				<>
					<div className={theme.title}>{title}</div>
					{content ?? descriptionContent}
				</>
			}
			onClick={onAdd}
		/>
	);
};

export default CardExtraViewAggregator;
